export const OfferStyles = {
  payment: 'font-bold min-h-min mb-6 mt-3  text-28px ',
  default: 'mb-3 font-bold'
}
